import {
  SUPPORT_SEARCH_CUSTOMER_RESET_STATUS,
  SUPPORT_SEARCH_CUSTOMER_START,
  SUPPORT_SEARCH_CUSTOMER_SUCCESS,
  SUPPORT_SEARCH_CUSTOMER_FAIL,
  CREATE_APPLICATION_START,
  CREATE_APPLICATION_SUCCESS,
  CREATE_APPLICATION_FAIL,
  GET_SUBSCRIBER_START,
  GET_SUBSCRIBER_SUCCESS,
  GET_SUBSCRIBER_FAIL,
  GET_APPLICATIONS_START,
  GET_APPLICATIONS_SUCCESS,
  GET_APPLICATIONS_FAIL,
  GET_DETAILED_APPLICATION_START,
  GET_DETAILED_APPLICATION_SUCCESS,
  GET_DETAILED_APPLICATION_FAIL,
  PATCH_HANDLER_APPLICATION_START,
  PATCH_HANDLER_APPLICATION_SUCCESS,
  PATCH_HANDLER_APPLICATION_FAIL,
  GET_BALANCE_START,
  GET_BALANCE_SUCCESS,
  GET_BALANCE_FAIL,
  GET_TRANSACTIONS_START,
  GET_TRANSACTIONS_SUCCESS,
  GET_TRANSACTIONS_FAIL,
  GET_BONUSES_SUCCESS,
  GET_BONUSES_START,
  GET_BONUSES_FAIL
} from './constants';

export const supportReducer = (
  state = {
    transactions: {},
    bonuses: {},
    customer: {},
    fetchingCustomer: false,
    statusSearchCustomer: false,
    supportSubscriber: [],
    applications: [],
    applicationsFetching: false,
    application: {},
    applicationFetching: false,
    fetching: false,
    balance: [],
    balanceFetching: false,
    bonusesFetching: false,
    error: null
  },
  action
) => {
  switch (action.type) {
    case SUPPORT_SEARCH_CUSTOMER_START:
      return { ...state, fetchingCustomer: true };
    case SUPPORT_SEARCH_CUSTOMER_SUCCESS:
      return {
        ...state,
        fetchingCustomer: false,
        statusSearchCustomer: false,
        customer: action.payload
      };
    case SUPPORT_SEARCH_CUSTOMER_FAIL:
      return {
        ...state,
        fetchingCustomer: false,
        statusSearchCustomer: true,
        error: action
      };
    case SUPPORT_SEARCH_CUSTOMER_RESET_STATUS: {
      return { ...state, statusSearchCustomer: false };
    }

    case CREATE_APPLICATION_START:
      return { ...state };
    case CREATE_APPLICATION_SUCCESS:
      return { ...state };
    case CREATE_APPLICATION_FAIL:
      return { ...state, error: action.payload };

    case GET_SUBSCRIBER_START:
      return { ...state, fetching: true };
    case GET_SUBSCRIBER_SUCCESS:
      return { ...state, fetching: false, supportSubscriber: action.payload };
    case GET_SUBSCRIBER_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case GET_APPLICATIONS_START:
      return { ...state, applicationsFetching: true };
    case GET_APPLICATIONS_SUCCESS:
      return { ...state, applicationsFetching: false, applications: action.payload };
    case GET_APPLICATIONS_FAIL:
      return { ...state, applicationsFetching: false, error: action.payload };

    case GET_DETAILED_APPLICATION_START:
      return { ...state, applicationFetching: true };
    case GET_DETAILED_APPLICATION_SUCCESS:
      return { ...state, applicationFetching: false, application: action.payload };
    case GET_DETAILED_APPLICATION_FAIL:
      return { ...state, applicationFetching: false, error: action.payload };

    case PATCH_HANDLER_APPLICATION_START:
      return { ...state, fetching: true };
    case PATCH_HANDLER_APPLICATION_SUCCESS:
      return {
        ...state,
        fetching: false,
        application: {
          ...state.application,
          request_status: action.payload?.data?.data?.request_status,
          amount: action.payload?.data?.data?.amount
            ? action.payload?.data?.data?.amount
            : state.application?.amount
        },
        applications: {
          ...state.applications,
          items: state.applications?.items.map((app) =>
            app.id === action.payload?.data?.data?.id_1
              ? {
                  ...app,
                  request_status: action.payload?.data?.data?.request_status
                }
              : { ...app }
          )
        }
      };
    case PATCH_HANDLER_APPLICATION_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case GET_BALANCE_START:
      return { ...state, balanceFetching: true };
    case GET_BALANCE_SUCCESS:
      return { ...state, balanceFetching: false, balance: action.payload.data };
    case GET_BALANCE_FAIL:
      return { ...state, balanceFetching: false, error: action.payload };

    case GET_TRANSACTIONS_START:
      return { ...state, fetching: true };
    case GET_TRANSACTIONS_SUCCESS:
      return { ...state, fetching: false, transactions: action.payload.data };
    case GET_TRANSACTIONS_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case GET_BONUSES_START:
      return { ...state, bonusesFetching: true };
    case GET_BONUSES_SUCCESS:
      return { ...state, bonusesFetching: false, bonuses: action.payload.data };
    case GET_BONUSES_FAIL:
      return { ...state, bonusesFetching: false, error: action.payload };

    default:
      return state;
  }
};
